import {
  RESET_SCRIPTS,
  RESET_SCRIPT,
  RESET_ERROR,
  GET_SCRIPTS,
  SET_SCRIPTS,
  API_ERROR,
  CREATE_SCRIPT,
  CREATE_SCRIPT_SUCCESS,
  GET_SCRIPT,
  SET_SCRIPT,
  EDIT_SCRIPT,
  EDIT_SCRIPT_SUCCESS,
  DELETE_SCRIPT,
  DELETE_SCRIPT_SUCCESS,
} from "./actionTypes";

const initialState = {
  errorScript: false,
  loadingScript: false,
  dataScript: null,
  successScript: false,
};

const Script = (state = initialState, action) => {
  switch (action.type) {
    case RESET_SCRIPTS:
      state = {
        ...state,
        errorScript: false,
        loadingScript: false,
        loadingScriptDelete: false,
        successScript: false,
        dataScript: null,
        dataScriptDelete: null,
      };
      break;
    case RESET_SCRIPT:
      state = {
        ...state,
        errorScript: false,
        loadingScript: false,
        successScript: false,
        dataScriptGetSet: null,
        dataScriptEditCreate: null,
      };
      break;
    case RESET_ERROR:
      state = {
        ...state,
        errorScript: false,
        loadingScript: false,
        loadingScriptEditCreate: false,
        loadingScriptActivate: false,
        successScript: false,
      };
      break;
    case GET_SCRIPTS:
      state = {
        ...state,
        errorScript: false,
        loadingScript: true,
        dataScript: null,
      };
      break;
    case SET_SCRIPTS:
      state = {
        ...state,
        errorScript: false,
        loadingScript: false,
        dataScript: action.payload,
      };
      break;
    case CREATE_SCRIPT:
      state = {
        ...state,
        errorScript: false,
        loadingScriptEditCreate: true,
        dataScriptEditCreate: action.payload,
        successScript: false,
      };
      break;
    case CREATE_SCRIPT_SUCCESS:
      state = {
        ...state,
        errorScript: false,
        loadingScriptEditCreate: false,
        dataScriptEditCreate: action.payload,
        successScript: true,
      };
      break;
    case GET_SCRIPT:
      state = {
        ...state,
        errorScript: false,
        loadingScript: true,
        dataScriptGetSet: null,
      };
      break;
    case SET_SCRIPT:
      state = {
        ...state,
        errorScript: false,
        loadingScript: false,
        dataScriptGetSet: action.payload,
      };
      break;
    case EDIT_SCRIPT:
      state = {
        ...state,
        errorScript: false,
        loadingScriptEditCreate: true,
        dataScriptEditCreate: action.payload,
        successScript: false,
      };
      break;
    case EDIT_SCRIPT_SUCCESS:
      state = {
        ...state,
        errorScript: false,
        loadingScriptEditCreate: false,
        dataScriptEditCreate: action.payload,
        successScript: true,
      };
      break;
    case API_ERROR:
      state = {
        ...state,
        errorScript: action.payload,
        loadingScript: false,
        loadingScriptDelete: false,
        successScript: false,
        loadingScriptEditCreate: false,
      };
      break;
    case DELETE_SCRIPT:
      state = {
        ...state,
        errorScript: false,
        loadingScriptDelete: true,
        dataScriptDelete: action.payload,
        successScript: false,
      };
      break;
    case DELETE_SCRIPT_SUCCESS:
      state = {
        ...state,
        errorScript: false,
        loadingScriptDelete: false,
        dataScriptDelete: action.payload,
        successScript: true,
      };
      break;
    default:
      // state = { ...state, errorScript: false, loadingScript: false };
      break;
  }
  return state;
};

export default Script;
